export class Site {
  public id: number;
  public intitule: string;
  public did: number;
  public societeId: number;
  public partenaireId: number;
  public transporteurId: number;

  constructor(init?: Partial<Site>) {
    Object.assign(this, init);
  }
}